<template>

	<dashboard-plugin
		name="Aantal reacties"
		instruction="De verdeling van de verschillende manieren om een melding af te handelen, zowel absoluut als relatief."
		:loading="loading"
		:loadedFirstTime="loadedFirstTime"
		:hasData="hasData"
	>

		<div class="flex flex-wrap mb-6">
			<p class="w-3/4 text-sm text-gray-600"> Aantal unieke oproepen: </p>
			<p class="w-1/4 text-sm font-bold"> {{uniqueCreatedNotificationsCount}} </p>
			<p class="w-3/4 text-sm text-gray-600"> Totaal aantal reacties op de oproepen: </p>
			<p class="w-1/4 text-sm font-bold"> {{totalAmountOfResponses}} </p>
		</div>

		<Pie
			v-if="notificationResponseCountChart"
			:data="notificationResponseCountChart"
			:key="JSON.stringify(notificationResponseCountChart)"
		/>

	</dashboard-plugin>

</template>

<script>

import Api from "../api";
import PieChart from "./common/PieChart";
import DashboardPlugin from "./common/DashboardPlugin";
import loader from "./mixins/loader";
import { Pie } from "vue-chartjs";

export default {
	name: 'notifications-response-count-pie-chart',

	mixins: [loader],
	components:
	{
        Pie,
		DashboardPlugin
	},

	data: function () {
		return {
			notificationResponseCountChart: null,
			uniqueCreatedNotificationsCount: null,
			totalAmountOfResponses: null,
		}
	},

	methods:
	{
		updateHandler()
		{
			this.updateChart();
		},

		async updateChart()
		{
			this.incrementLoading()

			// Get the boilerplate for the chart. This needs to be a copy to trigger reactivity
			let boilerplate = Object.assign({}, this.chartBoilerplate)

			// Load the count per event notification type.
			let response = await Api.getResponsesToNotificationsCount()
			let notificationResponses = response['counts'][0];

			this.uniqueCreatedNotificationsCount = response['uniqueCreatedNotificationsCount']

			let nullCount = Number(notificationResponses['null']) ?? 0
			let falseCount = Number(notificationResponses['false']) ?? 0
			let trueCount = Number(notificationResponses['true']) ?? 0

			this.totalAmountOfResponses = nullCount + falseCount + trueCount

			// Set the labels for the boilerplate. These are the names of the notificationTypeCounts
			boilerplate.labels = ['Niet gereageerd', 'Geweigerd', 'Geaccepteerd']

			// Set the data. These are the counts for each name of the notificationTypeCounts
			boilerplate['datasets'][0]['data'] = [nullCount, falseCount, trueCount]

			// Update the chart
			this.notificationResponseCountChart = boilerplate

			this.decrementLoading()
		}
	},

	computed:
	{
		chartBoilerplate()
		{
			return {
				labels: [],
				datasets: [{
					data: [],

					borderWidth: 2,
					borderColor: [
						// Genegeerd
						'rgb(239, 214, 19)',
						// Geweigerd
						'rgba(255, 84, 84)',
						// Geaccepteerd
						'rgba(61, 204, 91)',
					],
					backgroundColor: [
						// Genegeerd
						'rgb(239, 214, 19)',
						// Geweigerd
						'rgb(255, 84, 84)',
						// Geaccepteerd
						'rgb(61, 204, 91)',
					],
				}]
			}
		},

		hasData()
		{
			return this.piechartHasData(this.notificationResponseCountChart);
		}
	},

	watch:
		{
			// 'notificationResponseChart'(newVal)
			// {
			// 	console.log(newVal)
			// }

		},
}

</script>

<style lang="scss" scoped>

</style>
